import z from 'zod';
import { OwnerBaseSchema } from './owner-schema';

export const BusinessSchema = OwnerBaseSchema.extend({
  name: z.string().min(1, 'El nombre es obligatorio'),
  taxId: z.string().min(1, 'El RIF es obligatorio para reportes legales'), // RIF en Venezuela
  phone: z.string().optional(),
  address: z.string().optional(),
  
  // Cuentas de la empresa (Para el Header del TXT)
  bankAccounts: z.record(z.string(), z.object({
    bankName: z.string(),
    accountNumber: z.string().length(20, 'Debe tener 20 dígitos'),
    type: z.enum(['savings', 'checking']).default('checking'),
  })).optional(),
  
  // Configuración de nómina global
  payrollSettings: z.object({
    defaultCurrency: z.enum(['USD', 'BS', 'EUR']).default('BS'),
    paymentFrequency: z.enum(['weekly', 'biweekly', 'monthly']).default('biweekly'),
    
    // Sobreescrituras legales locales (Opcional)
    legalOverrides: z.object({
      minSalaryBs: z.number().optional(),
      cestaticketBs: z.number().optional(),
    }).optional(),
  }).optional(),
});

export type Business = z.infer<typeof BusinessSchema>;
export type BusinessWithId = Business & { id: string };
export type BusinessCreate = Omit<Business, 'id'> & { id?: string };
